import { Item } from '../Item';
import { OrderStatusEnum } from '../../graphql';
import { useDeleteCartItem } from '../../hooks/useDeleteCartItem';
import { useDuplicateCartItem } from '../../hooks/useDuplicateCartItem';
import { useEditCartItem } from '../../hooks/useEditCartItem';
import { CartItemEventHandler, CartItemProps } from '../../types';
import { Buttons } from '../Buttons';
import { Layout } from './Layout';

export type ItemsProps = React.HTMLAttributes<HTMLDivElement> & {
	items: CartItemProps[];
	divider?: React.ReactNode;
	checkIsItemEditable?: (id: string) => boolean;
	onEdit?: CartItemEventHandler;
	onDuplicate?: CartItemEventHandler;
	onDelete?: CartItemEventHandler;
	status?: OrderStatusEnum;
};

export const Items: React.FC<ItemsProps> = ({
	items,
	divider,
	checkIsItemEditable = () => false,
	onEdit,
	onDuplicate,
	onDelete,
	className,
	status,
	...props
}) => {
	const deleteCartItem = useDeleteCartItem();
	const duplicateCartItem = useDuplicateCartItem();
	const editCartItem = useEditCartItem();

	return (
		<Layout
			divider={divider}
			className={`cart-items${className ? ` ${className}` : ''}`}
			{...props}
			children={items.map(item => (
				<Item key={`item-${item.id}`} {...item} status={status}>
					{checkIsItemEditable(item.id) ?  (
						<Buttons
							id={item.id}
							onEdit={id => {
								editCartItem(id);
								onEdit && onEdit(id);
							}}
							onDuplicate={id => {
								duplicateCartItem(id);
								onDuplicate && onDuplicate(id);
							}}
							onDelete={id => {
								deleteCartItem(id);
								onDelete && onDelete(id);
							}}
						/>
					) : undefined}
				</Item>
			))}
		/>
	);
};
